import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import { getLastUserCredential } from '@mummssoftware/mumms-print/PDFComponents/CarePlanProblems/utils';
import { getTextEngine } from '../utils';
import { formatDateMMDDYY, YYYYMMDDtoMMDDYY } from '../formatters';
import { Other, InterventionLogicalEntity } from './form-engine-constants';
import defaults from '../translationDefaults/en';
/**
 * check subqchoices are active
 */

export const checkSubqchoices = el => el.subqchoices && el.subqchoices.length > 0 && el.subqchoices[0] !== null;
export const isSubqchoice = el => el.value === 'true' || el.value === true;
export const isSubqchoiceNotNull = el => el.value !== 'false' && el.value !== false && el.value !== null;
/**
 * update an item with specific ID in a tree structure
 * returns the tree structure
 */

const getParentQuestionPath = path => path.split('->').slice(0, -1).join('->');

export const updateStructure = obj => // eslint-disable-next-line no-nested-ternary
Array.isArray(obj) ? obj.map(o => updateStructure(o)) : obj ? _objectSpread(_objectSpread({}, obj), {}, {
  parentquestionpath: getParentQuestionPath(obj.questionpath)
}, checkSubqchoices(obj) ? {
  subqchoices: updateStructure(obj.subqchoices)
} : {}) : obj;
/**
 * find when a node has value and update all children node to false,
 */

export const hasNodeValue = obj => obj.value && obj.value !== 'false';
/**
 * text references for goals questions
 */

const whoItemsUS = ['Patient', 'Caregiver(s)', 'Family', 'Facility', Other];
const whoItemsES = ['Paciente', 'Cuidador(es)', 'Familia', 'Instalación', 'Otros'];
const goalTextUS = 'Goal will be achieved within';
const goalTextES = 'Meta se logrará dentro de';
const whoTextUS = 'Who';
const whoTextES = 'Quién';
const goalSummaryUS = 'Goals';
const goalSummaryES = 'Objetivos';
const commentUS = 'Comment';
const indicateUS = 'Indicate';
const whoLabel = 'who';
const periodLabel = 'period';
const commentLabel = 'comment';
const noComment = '';
const indicateLabel = 'indicate';
/**
 * check is Goal Type
 * "GoalLogicalEntity"
 */

export const checkGoalType = node => {
  const goalEntities = [whoTextUS, goalTextUS, commentUS];

  if (node.readonlydrawmode && checkSubqchoices(node)) {
    const items = node.subqchoices.map(el => el.questionlabel);
    const isGoal = items.every(el => goalEntities.includes(el));
    return isGoal;
  }

  return false;
};
/**
 * Function to get the goal summary
 * labelState = {
    "mainGoal": "Will provide dignity, comfort and peace as disease progresses",
    "Who": [
        "Patient",
        "Caregiver(s)",
        "Family","Other"
    ],
    "Goal will be achieved within": [
        " 24hr"
    ],
    "Comment": []
    "Indicate": []
}
 */

const getLabelId = itemLabel => {
  if (itemLabel === whoTextUS || itemLabel === whoTextES) {
    return whoLabel;
  }

  if (itemLabel === goalTextUS || itemLabel === goalTextES) {
    return periodLabel;
  }

  if (itemLabel === commentUS || itemLabel === noComment) {
    return commentLabel;
  }

  if (itemLabel === indicateUS) {
    return indicateLabel;
  }

  return itemLabel;
}; // todo dentro de for within SPANISH


export const getGoalSummary = data => {
  const labelState = {};
  const {
    subqchoices
  } = data;
  labelState.mainGoal = data.questionlabel;

  if (subqchoices && checkSubqchoices(data)) {
    subqchoices.forEach(item => {
      const itemLabel = getLabelId(item.questionlabel);
      labelState[itemLabel] = [];
      const itemSubqchoices = item.subqchoices;

      if (itemSubqchoices && checkSubqchoices(item)) {
        const notNullItems = itemSubqchoices.filter(isSubqchoiceNotNull); // Comment does not have subqchoices

        notNullItems.forEach(subitem => {
          if (subitem.questionlabel === Other) {
            const otherValue = getOtherValue(subitem);
            labelState[itemLabel].push(otherValue);
          } else {
            labelState[itemLabel].push(subitem.questionlabel);
          }
        });
      }

      if (itemLabel === commentLabel) {
        labelState[commentLabel].push(item.value);
      }
    });
  }

  const whoText = labelState.who ? labelState.who.toString() : '';
  const periodText = labelState.period ? labelState.period.toString() : '';
  const commentText = labelState.comment ? labelState.comment.toString() : '';
  const indicateText = labelState.indicate ? labelState.indicate.toString() : '';
  const periodStatement = periodText !== '' ? `within ${periodText}` : `${periodText}`;
  const commentStatement = commentText !== '' ? `- Comment :  ${commentText}` : '';
  let goalText;

  if (indicateText !== '') {
    goalText = `${whoText} ${labelState.mainGoal.toLowerCase()} ${indicateText}`;
  } else {
    goalText = `${whoText} ${labelState.mainGoal.toLowerCase()}`;
  }

  const finalStatement = `${goalText} ${periodStatement} ${commentStatement}`;
  return finalStatement;
};

const getOtherValue = input => {
  const hasvalue = checkSubqchoices(input);
  const text = hasvalue ? input.subqchoices[0].value || Other : Other;
  return text;
};

const isAddendumInput = input => input.cssclass === 'addendum';
/**
 * Fajita: hide unanswered/stamp flags on typed inputs (value 'true'/'false').
 * Callers already restrict this to controltype === 'input'. Overlay addendum
 * inputs keep a true/false stamp but display questionlabel instead.
 */


export const doNotDisplayText = subqchoice => !isAddendumInput(subqchoice) && (subqchoice.value === 'false' || subqchoice.value === 'true');
export const getReadOnlyInputText = input => {
  if (isAddendumInput(input)) {
    const text = input.questionlabel;
    return typeof text === 'string' && text ? getTextEngine(text) : '';
  }

  if (input.questionclass === goalSummaryUS) {
    return ` - Comments: ${input.value}`;
  }

  if (input.questionclass === goalSummaryES) {
    return ` - Objetivos: ${input.value}`;
  }

  const text = getTextEngine(input.value);
  return text;
};
export const getCPPReadOnlyInputText = input => {
  if (input.questionclass === goalSummaryUS) {
    return ` - Comments: ${input.value}`;
  }

  if (input.questionclass === goalSummaryES) {
    return ` - Objetivos: ${input.value}`;
  }

  const text = getTextEngine(input.value);
  let cppText = text;

  if (input.questionclass === InterventionLogicalEntity && input.effectivedate) {
    cppText = `${text}-${input.effectivedate}`;
  }

  return cppText;
};

const getInterventionText = subqchoice => subqchoice.effectivedate ? `${subqchoice.questionlabel} - ${subqchoice.effectivedate}` : `${subqchoice.questionlabel}`;

export const getReadText = subqchoice => subqchoice.questionclass === InterventionLogicalEntity ? getInterventionText(subqchoice) : `${subqchoice.questionlabel}`; // todo import form mumms/print - ISSUE RIGHT NOW

const getLastUserCredential = task => {
  const {
    modifiedpersonfirstname,
    modifiedpersonlastname,
    modifiedpersoncredentials
  } = task;

  if (modifiedpersonfirstname && modifiedpersonlastname) {
    if (modifiedpersoncredentials && modifiedpersoncredentials !== 'null') {
      return `${modifiedpersonfirstname} ${modifiedpersonlastname}, ${modifiedpersoncredentials}`;
    }

    return `${modifiedpersonfirstname} ${modifiedpersonlastname}`;
  }

  return ``;
};

export const getDCText = subqchoice => {
  const {
    modifiedpersonfirstname
  } = subqchoice;
  const credential = modifiedpersonfirstname && getLastUserCredential(subqchoice);
  const dcDate = subqchoice.dcdate ? YYYYMMDDtoMMDDYY(subqchoice.dcdate) : formatDateMMDDYY(subqchoice.modifieddatetime);
  return credential ? `${defaults.common.dcCPP} ${dcDate} by ${credential}` : `${defaults.common.dcCPP} ${dcDate}`;
};
export const getTaskDCText = task => `${defaults.common.dcCPP} ${task.statusdate}`;
/**
 * Check if a plan has tasks
 */

export const hasPlanTasks = patientCPP => !!(patientCPP !== null && patientCPP !== void 0 && patientCPP.numtasks) && Number(patientCPP === null || patientCPP === void 0 ? void 0 : patientCPP.numtasks) > 0;
export const isTaskSelected = task => task ? task.isselected === 'true' : false;
export const isF2Fform = name => name && name.includes('encounter');